var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.label,"disabled":!_vm.label}},[_c('el-button',_vm._g(_vm._b({attrs:{"circle":"","size":_vm.size,"disabled":_vm.disabled}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }